import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NguiAutoCompleteModule } from '@ngui/auto-complete';
import { TruncateModule } from '@yellowspot/ng-truncate';
import { TranslateModule } from '@ngx-translate/core';

import { SelectDropDownModule } from 'ngx-select-dropdown';
import { NgPipesModule } from 'ngx-pipes';
/* Import auth guard service */
import { AuthGuard } from '../../../../src/app/auth/auth.guard';
/* Import token interceptor */
import { TokenInterceptor } from '../../../../src/app/auth/token.interceptor';
import { JwtHelperService } from '@auth0/angular-jwt';
import { JwtModule  } from '@auth0/angular-jwt';

import { ToolsModule } from '../../../tools/src/lib/tools.module';
import {CtlUserForm} from '../../../../projects/projectmanagement/src/app/forms/user/CtlUserForm';


import { SchooladdComponent } from './schooladd/schooladd.component';
import { SchooloverviewComponent } from './schooloverview/schooloverview.component';
import { CtlSchoolForm } from './forms/school/CtlSchoolForm';

import { AddGradeClassComponent } from './forms/schoolGradeClass/ctl.school.gradeclass.component';
import { AddGradeSubjectComponent } from './forms/schoolGradeSubject/ctl.school.gradesubject.component';
import { AssignTeacherToClassComponent } from './forms/assignTeacherToClass/ctl.school.assignteacher.component';
import { ClassSubjectToGradeComponent } from './forms/schoolClassSubjectToGrade/ctl.school.classsubjecttograde.component';

import { SchoolClassSubjectComponent } from './forms/schoolUpdateClassSubject/ctl.school.classsubject.component';
import { ProvisionSchoolUserComponent } from './forms/provisionSchoolUser/ctl.provision.schooluser.component';
import { CtlAssignTeacherComponent } from './forms/schoolAssignTeacher/ctl.assign.teacher.component';
import { SetupYourSchoolComponent } from '../app/setupyourschool/setupyourschool.component';
import { AssignSubjectToGradeComponent } from './forms/assignSubjectToGrade/ctl.school.assignsubject.component';


export function tokenGetter() {
  return localStorage.getItem('token');
}

@NgModule({
  declarations: [
    AppComponent,
    SchooladdComponent,
    SchooloverviewComponent,
    SetupYourSchoolComponent,
    CtlSchoolForm,
    AddGradeClassComponent,
    AddGradeSubjectComponent,
    ClassSubjectToGradeComponent,
    SchoolClassSubjectComponent,
    AssignTeacherToClassComponent,
    ProvisionSchoolUserComponent,
    CtlAssignTeacherComponent,
    AssignSubjectToGradeComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    SelectDropDownModule,
    FormsModule,
    ReactiveFormsModule,
    NgPipesModule,
    ToolsModule,
    NguiAutoCompleteModule,
    TruncateModule,
    TranslateModule.forRoot(),
    JwtModule.forRoot({
      config: {
        tokenGetter
      },
    }),
  ],
  providers: [
    AuthGuard,
    JwtHelperService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    }
  ],
  exports: [SelectDropDownModule, CommonModule, CtlSchoolForm],
  bootstrap: [AppComponent]
})
export class AppModule { }

@NgModule({})
export class SchoolmanagementSharedModule{
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: AppModule,
      providers: []
    };
  }
}
